import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const PROJECTS = [
  {
    id: "001",
    title: "Site Clearance & Cut",
    location: "Matlock Bath",
    year: "2025",
    img: "https://images.pexels.com/photos/38520033/pexels-photo-38520033.jpeg?auto=compress&cs=tinysrgb&w=1600",
    cls: "md:col-span-7",
    aspect: "aspect-[16/10]",
  },
  {
    id: "002",
    title: "Foundation Pour",
    location: "Bakewell",
    year: "2025",
    img: "https://images.unsplash.com/photo-1610079732288-72a77bd816c9?q=80&w=1600&auto=format&fit=crop",
    cls: "md:col-span-5 md:mt-24",
    aspect: "aspect-[4/3]",
  },
  {
    id: "003",
    title: "Foul Drainage Install",
    location: "Wirksworth",
    year: "2024",
    img: "https://images.pexels.com/photos/37627673/pexels-photo-37627673.jpeg?auto=compress&cs=tinysrgb&w=1200",
    cls: "md:col-span-4",
    aspect: "aspect-[4/5]",
  },
  {
    id: "004",
    title: "Culvert Replacement",
    location: "Chesterfield",
    year: "2024",
    img: "https://images.unsplash.com/photo-1764524331704-c7a0d17067dd?q=80&w=1800&auto=format&fit=crop",
    cls: "md:col-span-8 md:mt-16",
    aspect: "aspect-[16/9]",
  },
  {
    id: "005",
    title: "Block Paved Driveway",
    location: "Belper",
    year: "2025",
    img: "https://images.pexels.com/photos/15360454/pexels-photo-15360454.jpeg?auto=compress&cs=tinysrgb&w=1400",
    cls: "md:col-span-5",
    aspect: "aspect-square",
  },
  {
    id: "006",
    title: "Reinforced Slab",
    location: "Cromford",
    year: "2026",
    img: "https://images.pexels.com/photos/29257600/pexels-photo-29257600.jpeg?auto=compress&cs=tinysrgb&w=1600",
    cls: "md:col-span-7 md:-mt-10",
    aspect: "aspect-[16/10]",
  },
];

export const Portfolio = () => (
  <section id="work" data-testid="portfolio-section" className="border-t border-line bg-coal-800 px-5 py-24 md:px-12 md:py-32">
    <div className="mb-14 grid gap-8 md:mb-24 md:grid-cols-12 md:items-end">
      <div className="md:col-span-7">
        <Reveal>
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.25em] text-ember">[ Selected work ]</p>
          <h2 className="font-display text-5xl uppercase leading-[0.85] tracking-tight text-white md:text-7xl">
            Recent<br />ground
          </h2>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="md:col-span-5">
        <p className="max-w-sm text-sm leading-relaxed text-steel md:ml-auto">
          A snapshot of jobs finished across Derbyshire — every one visited,
          quoted and completed by our own crew.
        </p>
      </Reveal>
    </div>

    <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8">
      {PROJECTS.map((p, i) => (
        <motion.figure
          key={p.id}
          data-testid={`project-card-${p.id}`}
          initial={{ opacity: 0, y: 60, clipPath: "inset(6% 6% 6% 6%)" }}
          whileInView={{ opacity: 1, y: 0, clipPath: "inset(0% 0% 0% 0%)" }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, delay: (i % 2) * 0.1, ease: [0.16, 1, 0.3, 1] }}
          className={`group relative overflow-hidden border border-line bg-coal-900 ${p.cls}`}
        >
          <div className={`${p.aspect} overflow-hidden`}>
            <img
              src={p.img}
              alt={`${p.title} — ${p.location}`}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
            />
          </div>
          <div className="absolute inset-0 bg-black/25 transition-opacity duration-500 group-hover:opacity-0" aria-hidden="true" />
          <figcaption className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 bg-gradient-to-t from-black/85 to-transparent p-5 pt-14">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ember">{p.id}</p>
              <p className="mt-1 font-display text-xl uppercase leading-none text-white md:text-2xl">{p.title}</p>
            </div>
            <p className="shrink-0 font-mono text-[10px] uppercase tracking-[0.2em] text-steel">
              {p.location} — {p.year}
            </p>
          </figcaption>
        </motion.figure>
      ))}
    </div>
  </section>
);
